<template>
  <div class="charge-language-dialog">
    <el-tooltip placement="bottom-end" style="flex: 1">
      <div slot="content" v-html="tooltip||$t('SeaExport.NoData')" />
      <el-input v-model="enValue" :disabled="disabled" />
    </el-tooltip>
    <el-tooltip class="item" placement="bottom-end" :disabled="disabled">
      <div slot="content" v-html="tooltip||$t('SeaExport.NoData')" />
      <span
        class="el-button el-button--primary el-button--mini"
        style="min-width:40px!important;margin-left:2px"
        type="primary"
        @click="showDialog=true"
      >...</span>
    </el-tooltip>
    <!--费用项语言配置弹窗-->
    <el-form>
      <el-dialog
        :title="$t('ChangeCharge.costDescription')"
        :visible.sync="showDialog"
        width="450px"
        append-to-body
      >
        <cargo-ag-grid
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="finalRowData"
          :auto-fit-content="false"
          style="width:100%;height:300px"
          @gridReady="params=>{gridApi=params.api}"
        />
        <span slot="footer" style="display: flex;justify-content: space-between;">
          <div v-show="!disabled">
            <el-button type="primary" @click="add">{{ $t('Payment.new') }}</el-button>
            <el-button type="danger" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
          </div>
          <div style="flex: 1;text-align: right;">
            <label @click="save">
              <el-button v-show="!disabled" class="is-enabled" type="primary">{{ $t('common.btn.confirm') }}</el-button>
              <el-button v-if="disabled" @click="showDialog=false">{{ $t('common.btn.close') }}</el-button>
            </label>
          </div>
        </span>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import DateUtils from '@/utils/dateUtils'
export default {
  name: 'ChargeLanguageDialog',
  components: {},
  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    items: { type: Array, default: () => [] }
  },
  data() {
    return {
      rowData: [],
      showDialog: false,
      tooltip: '',
      enValue: this.value,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        rowMultiSelectWithClick: true,
        suppressCellSelection: true,
        suppressRowSelection: false,
        suppressRowClickSelection: false,
        rowHeight: 32,
        frameworkComponents: { CargoAgGridCommonInputEditor, CargoAgGridAdvanceSelectEditor, CargoAgGridSelectEditor },
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          // 清除单选
          event.api.clearFocusedCell()
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: p => {
          this.rowClicked(p)
        }
      },
      gridApi: null,
      selectedRegionCode: null,
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        regionSet: [] // 国家地区
      },
      regions: [],
      delRegionUuids: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 40, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: `${this.$t('baseInfo.partner.region')} (${this.$t('baseInfo.partner.area')})`, field: 'regionCode', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, 'code')
          },
          editable: !this.disabled,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_Country,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'code',
              staticOptions: [...this.currentViewCacheData.regionSet],
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('ChangeCharge.chargeLanguage'),
          field: 'chargeLanguage',
          width: 200,
          editable: !this.disabled,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            inputProps: {
              maxLength: 400
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ]
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    }
  },
  watch: {
    showDialog(newVal) {
      if (!newVal) {
        this.save()
      } else {
        this.rowData = this.items
      }
    },
    value(val) {
      this.enValue = val
    },
    enValue(newLocalValue) {
      this.$emit('input', newLocalValue)
    }
  },
  async created() {
    this.gridOptions = {
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      rowSelection: 'multiple',
      singleClickEdit: true,
      frameworkComponents: {
        CargoAgGridAdvanceSelectEditor,
        CargoAgGridCommonInputEditor
      }
    }
    await cache.load(cacheName.CONFIG)
    this.initRegionSet()
  },
  methods: {
    rowClicked(event) {
      if (event) {
        this.selectedRegionCode = event.data
      }
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedRegionCode = node.data
          }
        })
      }
    },
    async onCellChange(params) {
      const newParams = {
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        originalValue: params.oldValue
      }
      await this.gridItemEditEndHandler(newParams)
    },
    gridItemEditEndHandler(params) {
      const regionItem = params.data
      regionItem.modifiedBy = this.$store.getters.userId
      regionItem.dateModified = DateUtils.formatStandardDateTime(new Date())
      if (this.regions.includes(regionItem)) {
        this.regions = this.regions.filter(item => item !== regionItem)
      }
      this.regions.push(regionItem)
    },
    add() {
      this.rowData.push({ regionCode: '' })
      this.$nextTick(() => {
        this.gridApi.deselectAll()
        const nodes = this.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
        this.selectedRegionCode = lastNode.data
      })
    },
    remove() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length && this.rowData) {
        for (let i = this.rowData.length - 1; i >= 0; --i) {
          const row = this.rowData[i]
          if (rows.includes(row)) {
            if (row.uuid) {
              if (row.uuid && !this.delRegionUuids.includes(row.uuid)) {
                this.delRegionUuids.push(row.uuid)
              }
              row.deleted = true
            } else {
              this.rowData.splice(i, 1)
            }
          }
        }
      }
      const tempRowData = this.rowData
      this.rowData = []
      this.$nextTick(() => {
        this.rowData = tempRowData
      })
    },
    save() {
      this.$emit('childChargeLanguage', this.regions, this.delRegionUuids)
      this.showDialog = false
    },
    // 国家地区缓存数据
    initRegionSet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Country)
      this.currentViewCacheData.regionSet = Array.from(new Set(results))
    }
  }
}
</script>

<style lang="scss" scoped>
.charge-language-dialog {
  display: flex;
  flex-direction: row;
  padding-right: 3px;

  .ag-header {
    display: none;
  }

  .is-enabled {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
    cursor: pointer;
  }
}
</style>
